"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AREA_FIELD_META = void 0;
// Building-area fields tracked by the Update vs Correction diff. Used by the
// edit dialog and the history timeline so they show the same set of fields in
// the same order.
var AREA_FIELD_META = [
    { key: "areaNumber", label: "Area Number", group: "Basic" },
    { key: "description", label: "Description", group: "Basic" },
    { key: "buildingName", label: "Building", group: "Basic" },
    { key: "areaType", label: "Area Type", group: "Basic" },
    { key: "areaCategory", label: "Area Category", group: "Basic" },
    { key: "areaSubType", label: "Area Sub-Type", group: "Basic" },
    { key: "areaPhysicality", label: "Physicality", group: "Basic" },
    { key: "isServiceArea", label: "Service Area", group: "Basic" },
    { key: "isPublic", label: "Public", group: "Basic" },
    { key: "isLeaseable", label: "Leaseable", group: "Basic" },
    { key: "isActive", label: "Active", group: "Basic" },
    { key: "physicalAddress", label: "Physical Address", group: "Location" },
    { key: "floorNumber", label: "Floor Number", group: "Location" },
    { key: "areaSize", label: "Area Size (m²)", group: "Location" },
    { key: "establishmentDate", label: "Establishment Date", group: "Dates" },
    { key: "disestablishmentDate", label: "Disestablishment Date", group: "Dates" },
    { key: "parentAreaId", label: "Parent Area", group: "Hierarchy" },
    { key: "parentAreas", label: "Parent Areas", group: "Hierarchy" },
    { key: "premiseId", label: "Premise ID", group: "Hierarchy" },
    { key: "hasOwnEskomPod", label: "Has Own Eskom POD", group: "Supply" },
    { key: "notes", label: "Notes", group: "Other" },
];
exports.AREA_FIELD_META = AREA_FIELD_META;
